import { render, staticRenderFns } from "./LastSearches.vue?vue&type=template&id=5ca031a6&scoped=true&"
import script from "./LastSearches.vue?vue&type=script&lang=js&"
export * from "./LastSearches.vue?vue&type=script&lang=js&"
import style0 from "./LastSearches.vue?vue&type=style&index=0&id=5ca031a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca031a6",
  null
  
)

export default component.exports